import { actionPlanTaskFields } from './ActionPlanTaskFields';

/**
 * Fields for MAP collaborators.
 *
 * Current use cases:
 *  - Create/Edit/View Room flows
 *  - MAP Editor (rooms table, rooms overview page)
 *  - Task conflict resolution dialog
 */
export const actionPlanCollaboratorsFields = `
  collaborators {
    id
    collaboratorType
    email
    firstName
    lastName
    photo
  }
`;

/**
 * Fields for MAPs.
 *
 * Current use cases regarding MAPs:
 *  - Create/Edit/View Room flows
 *  - MAP Editor
 */
export const actionPlanFields = `
  id
  lastActivityAt
  name
  updatedAt
  visibility
  collaborators {
    id
    collaboratorType
    email
    firstName
    lastName
    photo
  }
  tasks {
    ${actionPlanTaskFields}
  }
`;

/**
 * Fields used by the rooms listing, to display MAP information.
 *
 * Current use cases regarding MAPs:
 *  - Rooms table
 */
export const actionPlanRoomListingFields = `
  id
  name
  updatedAt
  tasks {
    dueDate
    milestone
    status
  }
`;
